/**
 * Agenda — client-side rendering via Storefront API
 *
 * Fetches all session_date metaobjects in one call, filters + sorts
 * client-side, groups by month, and paginates locally.
 *
 * NOTE: For counselors and session_type to appear, the corresponding
 * product metafields (joule.session_counselor, joule.session_type) must be
 * exposed in Shopify Admin → Settings → Apps and sales channels →
 * Storefront API → Edit "Products" metafield access.
 */

(function () {
  'use strict';

  // ── PAGE BUILDING CONSTANTS ──────────────────────────────────────────────
  var MONTHS_PER_PAGE = 3;      // default months shown per page
  var SESSION_THRESHOLD = 16;   // if 2 months already reach this, stop at 2

  var FILTER_ICON_SVG = '<svg class="agenda__filter-icon" width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><line x1="0" y1="1" x2="16" y2="1" stroke="currentColor" stroke-width="1.5"/><line x1="3" y1="5.5" x2="13" y2="5.5" stroke="currentColor" stroke-width="1.5"/><line x1="6" y1="10" x2="10" y2="10" stroke="currentColor" stroke-width="1.5"/></svg>';

  // Inlined pin SVG from icon-pack snippet
  var PIN_SVG = '<svg class="icon icon-pin" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 12C12.55 12 13.0208 11.8042 13.4125 11.4125C13.8042 11.0208 14 10.55 14 10C14 9.45 13.8042 8.97917 13.4125 8.5875C13.0208 8.19583 12.55 8 12 8C11.45 8 10.9792 8.19583 10.5875 8.5875C10.1958 8.97917 10 9.45 10 10C10 10.55 10.1958 11.0208 10.5875 11.4125C10.9792 11.8042 11.45 12 12 12ZM12 19.35C14.0333 17.4833 15.5417 15.7875 16.525 14.2625C17.5083 12.7375 18 11.3833 18 10.2C18 8.38333 17.4208 6.89583 16.2625 5.7375C15.1042 4.57917 13.6833 4 12 4C10.3167 4 8.89583 4.57917 7.7375 5.7375C6.57917 6.89583 6 8.38333 6 10.2C6 11.3833 6.49167 12.7375 7.475 14.2625C8.45833 15.7875 9.96667 17.4833 12 19.35ZM12 22C9.31667 19.7167 7.3125 17.5958 5.9875 15.6375C4.6625 13.6792 4 11.8667 4 10.2C4 7.7 4.80417 5.70833 6.4125 4.225C8.02083 2.74167 9.88333 2 12 2C14.1167 2 15.9792 2.74167 17.5875 4.225C19.1958 5.70833 20 7.7 20 10.2C20 11.8667 19.3375 13.6792 18.0125 15.6375C16.6875 17.5958 14.6833 19.7167 12 22Z" fill="inherit"/></svg>';
  var MONEY_SVG = '<svg class="icon icon-money" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M13.82 4.67993C14.4866 4.67993 15.1066 4.75327 15.68 4.89993C16.2533 5.0466 16.8066 5.2666 17.34 5.55993L16.54 7.25993C16.14 7.05993 15.7066 6.87993 15.24 6.71993C14.7733 6.55993 14.3 6.47993 13.82 6.47993C13.3533 6.47993 12.92 6.55327 12.52 6.69993C12.1333 6.83327 11.7933 7.0466 11.5 7.33993C11.2066 7.63327 10.9533 7.99993 10.74 8.43993C10.54 8.87993 10.3866 9.3866 10.28 9.95993H14.88V11.3999H10.14C10.1266 11.5066 10.12 11.6133 10.12 11.7199C10.12 11.8266 10.12 11.9466 10.12 12.0799C10.12 12.1866 10.12 12.3066 10.12 12.4399C10.12 12.5733 10.1266 12.7066 10.14 12.8399H14.26V14.2599H10.3C10.4333 14.9399 10.66 15.5199 10.98 15.9999C11.3 16.4799 11.7066 16.8466 12.2 17.0999C12.7066 17.3533 13.3 17.4799 13.98 17.4799C14.5 17.4799 15.0066 17.4199 15.5 17.2999C16.0066 17.1799 16.4666 17.0333 16.88 16.8599V18.6999C16.48 18.8733 16.0333 19.0199 15.54 19.1399C15.0466 19.2599 14.4866 19.3199 13.86 19.3199C12.7933 19.3199 11.8666 19.1199 11.08 18.7199C10.3066 18.3066 9.67997 17.7266 9.19997 16.9799C8.71997 16.2199 8.37997 15.3133 8.17997 14.2599H6.65997V12.8399H8.01997C8.00664 12.7066 7.99331 12.5866 7.97997 12.4799C7.97997 12.3599 7.97997 12.2266 7.97997 12.0799C7.97997 11.9466 7.97997 11.8199 7.97997 11.6999C7.99331 11.5666 7.99997 11.4666 7.99997 11.3999H6.65997V9.95993H8.15997C8.33331 8.87993 8.65997 7.9466 9.13997 7.15993C9.61997 6.37327 10.2533 5.7666 11.04 5.33993C11.84 4.89993 12.7666 4.67993 13.82 4.67993Z" fill="inherit"/></svg>';
  var CLOCK_SVG = '<svg class="icon icon-clock" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 21C10.75 21 9.57917 20.7625 8.4875 20.2875C7.39583 19.8125 6.44583 19.1708 5.6375 18.3625C4.82917 17.5542 4.1875 16.6042 3.7125 15.5125C3.2375 14.4208 3 13.25 3 12C3 10.75 3.2375 9.57917 3.7125 8.4875C4.1875 7.39583 4.82917 6.44583 5.6375 5.6375C6.44583 4.82917 7.39583 4.1875 8.4875 3.7125C9.57917 3.2375 10.75 3 12 3C13.25 3 14.4208 3.2375 15.5125 3.7125C16.6042 4.1875 17.5542 4.82917 18.3625 5.6375C19.1708 6.44583 19.8125 7.39583 20.2875 8.4875C20.7625 9.57917 21 10.75 21 12C21 13.25 20.7625 14.4208 20.2875 15.5125C19.8125 16.6042 19.1708 17.5542 18.3625 18.3625C17.5542 19.1708 16.6042 19.8125 15.5125 20.2875C14.4208 20.7625 13.25 21 12 21ZM14.8 16.2L16.2 14.8L13 11.6V7H11V12.4L14.8 16.2ZM12 19C13.95 19 15.6042 18.3208 16.9625 16.9625C18.3208 15.6042 19 13.95 19 12C19 10.05 18.3208 8.39583 16.9625 7.0375C15.6042 5.67917 13.95 5 12 5C10.05 5 8.39583 5.67917 7.0375 7.0375C5.67917 8.39583 5 10.05 5 12C5 13.95 5.67917 15.6042 7.0375 16.9625C8.39583 18.3208 10.05 19 12 19Z" fill="inherit"/></svg>';

  // ── STATE ──────────────────────────────────────────────────────────────────
  var allSessions = [];  // full filtered+sorted list, never mutated after load
  var activeFilters = []; // currently selected filter keys (OR logic)
  var pages = [];         // array of pages; each page is an array of month groups
  var currentPage = 0;
  var container;
  var paginationEl;

  // ── INIT ───────────────────────────────────────────────────────────────────
  function init() {
    container = document.getElementById('agenda-container');
    paginationEl = document.getElementById('agenda-pagination');
    if (!container) return;

    // Bind filter UI immediately — doesn’t depend on data loading
    bindFilterEvents();

    var token = container.dataset.storefrontToken;
    var apiVersion = container.dataset.apiVersion || '2024-01';

    if (!token) {
      container.innerHTML = '<p class="agenda__empty">Storefront token niet geconfigureerd.</p>';
      return;
    }

    container.innerHTML = '<p class="agenda__loading">Laden...</p>';

    fetchSessions(token, apiVersion)
      .then(function (nodes) {
        console.log('[Agenda] Raw nodes (' + nodes.length + '):', nodes);
        var normalized = nodes.map(normalizeSession);
        console.log('[Agenda] Normalized (' + normalized.length + '), first sample:', normalized[0]);
        allSessions = filterAndSort(normalized);
        console.log('[Agenda] After filter+sort (' + allSessions.length + '):', allSessions);
        buildFilterChips();
        pages = buildPages(groupByMonth(allSessions));

        if (allSessions.length === 0) {
          container.innerHTML = '<p class="agenda__empty">Er zijn momenteel geen aankomende sessies gepland.</p>';
          if (paginationEl) paginationEl.innerHTML = '';
          return;
        }

        renderPage(0);
      })
      .catch(function (err) {
        console.error('[Agenda]', err);
        container.innerHTML = '<p class="agenda__empty">Er is een fout opgetreden bij het laden van de agenda.</p>';
      });
  }

  // ── FETCH ──────────────────────────────────────────────────────────────────
  function fetchSessions(token, apiVersion) {
    var query = [
      '{',
      '  metaobjects(type: "session_date", first: 250) {',
      '    nodes {',
      '      id',
      '      handle',
      '      fields {',
      '        key',
      '        value',
      '        reference {',
      '          ... on Product {',
      '            title',
      '            handle',
      '            onlineStoreUrl',
      '            featuredImage {',
      '              url',
      '              altText',
      '            }',
      '            priceRange {',
      '              minVariantPrice {',
      '                amount',
      '              }',
      '            }',
      '            sessionType: metafield(namespace: "joule", key: "session_type") {',
      '              value',
      '            }',
      '            sessionDuration: metafield(namespace: "joule", key: "session_duration") {',
      '              value',
      '            }',
      '            isMomsOnly: metafield(namespace: "joule", key: "is_moms_only") {',
      '              value',
      '            }',
      '            counselorsMeta: metafield(namespace: "joule", key: "session_counselor") {',
      '              references(first: 5) {',
      '                nodes {',
      '                  ... on Metaobject {',
      '                    fields {',
      '                      key',
      '                      value',
      '                    }',
      '                  }',
      '                }',
      '              }',
      '            }',
      '          }',
      '        }',
      '      }',
      '    }',
      '  }',
      '}'
    ].join('\n');

    return fetch('/api/' + apiVersion + '/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token
      },
      body: JSON.stringify({ query: query })
    })
      .then(function (res) {
        console.log('[Agenda] GraphQL response status:', res.status);
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (json) {
        if (json.errors) {
          console.warn('[Agenda] GraphQL errors:', json.errors);
        }
        return (json.data && json.data.metaobjects && json.data.metaobjects.nodes) || [];
      });
  }

  // ── NORMALIZE ──────────────────────────────────────────────────────────────
  function normalizeSession(node) {
    var fields = {};
    var product = null;

    node.fields.forEach(function (f) {
      fields[f.key] = f.value;
      // The product reference field key may be "product" or "linked_product"
      if ((f.key === 'product' || f.key === 'linked_product') && f.reference) {
        product = f.reference;
      }
    });

    var counselors = [];
    if (product && product.counselorsMeta && product.counselorsMeta.references) {
      product.counselorsMeta.references.nodes.forEach(function (n) {
        if (!n.fields) return;
        var nameField = null;
        for (var i = 0; i < n.fields.length; i++) {
          if (n.fields[i].key === 'name') { nameField = n.fields[i]; break; }
        }
        if (nameField && nameField.value) counselors.push(nameField.value);
      });
    }

    return {
      id: node.id,
      handle: node.handle || '',
      date: fields.date_start || fields.date || '',
      time_start: formatTime(fields.date_start || fields.date || ''),
      time_end: formatTime(fields.date_end || ''),
      location: fields.location || '',
      capacity: parseInt(fields.capacity, 10) || 0,
      spots_taken: parseInt(fields.spots_taken, 10) || 0,
      price: fields.price || null,
      is_cancelled: fields.is_cancelled === 'true',
      booking_closed: fields.booking_closed === 'true',
      is_traject: fields.t_is_traject === 'true' || !!fields.y_yoga_traject,
      traject_count: (function () {
        // Sub-sessions live in t_trajectsessies (trajecten) or y_yoga_traject (yoga)
        var list = fields.t_trajectsessies || fields.y_yoga_traject;
        if (!list) return 0;
        try { return JSON.parse(list).length; } catch (e) { return 0; }
      })(),
      product: product ? {
        title: product.title || '',
        handle: product.handle || '',
        url: product.onlineStoreUrl || ('/products/' + product.handle),
        image: product.featuredImage || null,
        sessionType: (product.sessionType && product.sessionType.value) || null,
        sessionDuration: (product.sessionDuration && product.sessionDuration.value) || null,
        isMomsOnly: !!(product.isMomsOnly && product.isMomsOnly.value === 'true'),
        counselors: counselors,
        price: (product.priceRange && product.priceRange.minVariantPrice && product.priceRange.minVariantPrice.amount) || null
      } : null
    };
  }

  // ── FILTER & SORT ──────────────────────────────────────────────────────────
  function filterAndSort(sessions) {
    // Start of today in local time — avoids UTC-midnight shifting the day
    var today = new Date();
    today.setHours(0, 0, 0, 0);

    return sessions
      .filter(function (s) {
        if (s.is_cancelled) return false;
        if (!s.date) {
          console.warn('[Agenda] Session missing date, skipping:', s.id);
          return false;
        }
        // Take only the YYYY-MM-DD part (handles datetime strings too),
        // then parse as LOCAL midnight so timezone doesn't shift the day.
        var parts = s.date.substring(0, 10).split('-');
        var sessionDate = new Date(
          parseInt(parts[0], 10),
          parseInt(parts[1], 10) - 1,
          parseInt(parts[2], 10)
        );
        var passes = !isNaN(sessionDate.getTime()) && sessionDate >= today;
        if (!passes) {
          console.log('[Agenda] Filtered out — id:', s.id, '| date:', s.date, '| is_cancelled:', s.is_cancelled);
        }
        return passes;
      })
      .sort(function (a, b) {
        return a.date < b.date ? -1 : a.date > b.date ? 1 : 0;
      });
  }

  // ── BUILD PAGES ────────────────────────────────────────────────────────────
  // Each page holds up to MONTHS_PER_PAGE month groups, but stops at 2 months
  // early if the first 2 months combined already reach SESSION_THRESHOLD sessions.
  function buildPages(groups) {
    var result = [];
    var i = 0;
    while (i < groups.length) {
      var pageGroups = [groups[i]];
      var count = groups[i].sessions.length;

      if (i + 1 < groups.length) {
        count += groups[i + 1].sessions.length;
        pageGroups.push(groups[i + 1]);

        if (count >= SESSION_THRESHOLD) {
          // 2 months is enough — stop here
          i += 2;
        } else if (i + 2 < groups.length) {
          // Add a 3rd month
          pageGroups.push(groups[i + 2]);
          i += 3;
        } else {
          i += 2;
        }
      } else {
        i += 1;
      }

      result.push(pageGroups);
    }
    return result;
  }

  // ── RENDER PAGE ────────────────────────────────────────────────────────────
  function renderPage(page) {
    currentPage = page;
    var pageGroups = pages[page] || [];

    container.innerHTML = pageGroups.map(renderMonthGroup).join('');

    var totalPages = pages.length;
    if (paginationEl) {
      paginationEl.innerHTML = totalPages > 1 ? renderPagination(page, totalPages) : '';
      if (totalPages > 1) bindPaginationEvents();
    }

    // Scroll to container top (with offset for sticky header)
    var top = container.getBoundingClientRect().top + window.scrollY - 100;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  // ── GROUP BY MONTH ─────────────────────────────────────────────────────────
  function groupByMonth(sessions) {
    var groups = [];
    sessions.forEach(function (s) {
      var month = s.date.substring(0, 7); // YYYY-MM
      var existing = null;
      for (var i = 0; i < groups.length; i++) {
        if (groups[i].month === month) { existing = groups[i]; break; }
      }
      if (existing) {
        existing.sessions.push(s);
      } else {
        groups.push({ month: month, label: formatMonthLabel(month), sessions: [s] });
      }
    });
    return groups;
  }

  function formatMonthLabel(monthKey) {
    try {
      // Use middle of month to avoid DST edge cases
      var d = new Date(monthKey + '-15T12:00:00');
      var label = d.toLocaleDateString('nl-NL', { month: 'long', year: 'numeric' });
      return label.charAt(0).toUpperCase() + label.slice(1);
    } catch (e) {
      return monthKey;
    }
  }

  // ── RENDER MONTH GROUP ─────────────────────────────────────────────────────
  function renderMonthGroup(group) {
    return '<div class="agenda__month-group flex flex-col gap-y-4">'
      + '<h2 class="agenda__month-heading">' + escHtml(group.label) + '</h2>'
      + '<div class="agenda__month-grid flex flex-col gap-y-10 md:grid md:grid-cols-3 md:gap-x-4 md:gap-y-12 lg:grid-cols-4">'
      + group.sessions.map(renderCard).join('')
      + '</div>'
      + '</div>';
  }

  // ── RENDER CARD (mirrors product-item snippet HTML exactly) ────────────────
  function renderCard(session) {
    var p = session.product;
    if (!p) return '';

    var isFull = session.booking_closed || (session.capacity > 0 && session.spots_taken >= session.capacity);

    // Date overlay values — session.date may be a full ISO datetime string
    var dateObj = new Date(session.date);
    var monthAbbr = dateObj.toLocaleDateString('nl-NL', { month: 'short' }).replace('.', '').toUpperCase();
    var dayNum = dateObj.getDate();

    // Image
    var imageHtml = '';
    if (p.image) {
      imageHtml = '<img class="product-item__image row-1 col-1" src="' + escAttr(p.image.url) + '" alt="' + escAttr(p.image.altText || p.title) + '" loading="lazy">'
        + '<div class="product-item__image-overlay row-1 col-1 bg-[rgba(0,0,0,0.2)] z-1 w-full h-full"></div>';
    } else {
      imageHtml = '<div class="product-item__image-placeholder row-1 col-1 bg-foreground w-full h-full"></div>';
    }

    var dateOverlay = '<div class="product-item__date-overlay row-1 col-1 z-2 w-fit h-fit flex flex-col items-center justify-center gap-y-3">'
      + '<div class="product-item__month font-primary text-background text-3xl font-normal">' + escHtml(monthAbbr) + '</div>'
      + '<div class="product-item__date font-primary text-7xl text-background">' + dayNum + '</div>'
      + '</div>';

    // Details
    var sessionTypeText = p.sessionType || '';
    var sessionTypeLabel = (session.is_traject && session.traject_count > 0)
      ? sessionTypeText + ' – ' + session.traject_count + ' SESSIES'
      : sessionTypeText;
    var sessionTypeLine = sessionTypeLabel
      ? '<p class="product-item__session-type font-mono uppercase opacity-50 font-light text-xs">' + escHtml(sessionTypeLabel) + '</p>'
      : '';

    var counselorLine = '';
    if (p.counselors && p.counselors.length > 0) {
      var byline = p.counselors.map(function (name, i) {
        return i === 0 ? 'door ' + escHtml(name) : '& ' + escHtml(name);
      }).join(' ');
      counselorLine = '<p class="product-item__hosts opacity-50 font-light text-xs">' + byline + '</p>';
    }

    var locationLine = session.location
      ? '<div class="product-item__location flex items-center gap-x-2">'
        + '<div class="product-item__location-icon">' + PIN_SVG + '</div>'
        + '<p class="text-xs">' + escHtml(session.location) + '</p>'
        + '</div>'
      : '';

    var timeslotLine = '';
    if (session.is_traject) {
      if (p.sessionDuration) {
        timeslotLine = '<div class="product-item__timeslot flex items-center gap-x-2">'
          + '<div class="product-item__timeslot-icon">' + CLOCK_SVG + '</div>'
          + '<p class="text-xs">' + escHtml(p.sessionDuration) + '</p>'
          + '</div>';
      }
    } else if (session.time_start && session.time_end) {
      timeslotLine = '<div class="product-item__timeslot flex items-center gap-x-2">'
        + '<div class="product-item__timeslot-icon">' + CLOCK_SVG + '</div>'
        + '<p class="text-xs">' + escHtml(session.time_start) + ' \u2013 ' + escHtml(session.time_end) + '</p>'
        + '</div>';
    }

    var displayPrice = session.price || (p.price ? parseFloat(p.price).toFixed(2) : null);
    var priceLine = displayPrice
      ? '<div class="product-item__price flex items-center gap-x-2">'
        + '<div class="product-item__price-icon">' + MONEY_SVG + '</div>'
        + '<p class="text-xs">' + escHtml(String(displayPrice)) + '</p>'
        + '</div>'
      : '';

    // CTA button — mirrors button snippet secondary style
    var btnBase = 'btn btn--secondary font-mono font-regular uppercase underline tracking-wide disable:opacity-40 disable:no-underline disable:pointer-events-none';
    var ctaBtnText = session.is_traject ? 'Boek traject' : 'Boek sessie';
    var ctaHtml = isFull
      ? '<a href="#" class="product-item__cta-btn ' + btnBase + ' disable">Volzet</a>'
      : '<a href="' + escAttr(p.url + '?session=' + session.handle + '#boek-sessie') + '" class="product-item__cta-btn ' + btnBase + '">' + ctaBtnText + '</a>';

    var momsOnlyBadge = p.isMomsOnly
      ? '<span class="product-item__moms-only row-1 col-1 self-start justify-self-start z-3 m-3 px-3 py-1 bg-product-card-background text-xs rounded-md font-normal">Moms only</span>'
      : '';

    return '<div class="product-item flex flex-col md:h-stretch md:w-full">'
      + '<a href="' + escAttr(p.url) + '" class="product-item__image-wrapper grid grid-rows-1 grid-cols-1 justify-items-center items-center rounded-t-2xl overflow-hidden aspect-3/2 min-h-fit">'
      + imageHtml
      + dateOverlay
      + momsOnlyBadge
      + '</a>'
      + '<div class="product-item__details flex flex-col bg-product-card-background gap-y-5 px-4 pt-5 pb-4 h-full">'
      + '<div class="product-item__details-main flex flex-col gap-y-1">'
      + sessionTypeLine
      + '<h3 class="product-item__title font-secondary text-base font-normal">' + escHtml(p.title) + '</h3>'
      + counselorLine
      + '</div>'
      + '<div class="product-item__meta flex flex-col gap-y-1 md:h-full">'
      + locationLine
      + timeslotLine
      + priceLine
      + '<div class="product-item__cta self-end md:mt-auto">' + ctaHtml + '</div>'
      + '</div>'
      + '</div>'
      + '</div>';
  }

  // ── RENDER PAGINATION ──────────────────────────────────────────────────────
  var ARROW_LEFT_SVG = '<svg class="icon icon-arrow-left btn__icon w-4" xmlns="http://www.w3.org/2000/svg" width="18" height="21" viewBox="0 0 18 21" fill="none"><mask id="mask0_2226_2641" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="21"><path d="M18 0.905273H0.5V20.9053H18V0.905273Z" fill="white"/></mask><g mask="url(#mask0_2226_2641)"><path d="M0.941413 10.4638L0.500014 10.9052L0.941413 11.3466L7.50391 17.9092L7.94531 18.3506L8.82812 17.4678L8.38671 17.0264L2.89061 11.5302L17.3203 11.5302L17.9453 11.5302L17.9453 10.2802L17.3203 10.2802L2.89061 10.2802L8.38671 4.78415L8.82812 4.34274L7.94531 3.45995L7.50391 3.90134L0.941413 10.4638Z" fill="inherit"/></g></svg>';
  var ARROW_RIGHT_SVG = '<svg class="icon icon-arrow-right btn__icon w-4" xmlns="http://www.w3.org/2000/svg" width="18" height="21" viewBox="0 0 18 21" fill="none"><g clip-path="url(#clip0_723_5282)"><path d="M17.5039 11.3467L17.9453 10.9053L17.5039 10.4639L10.9414 3.90137L10.5 3.45996L9.61719 4.34277L10.0586 4.78418L15.5547 10.2803H1.125H0.5V11.5303H1.125H15.5547L10.0586 17.0264L9.61719 17.4678L10.5 18.3506L10.9414 17.9092L17.5039 11.3467Z" fill="inherit"/></g><defs><clipPath id="clip0_723_5282"><rect width="17.5" height="20" fill="inherit" transform="translate(0.5 0.905273)"/></clipPath></defs></svg>';

  var BTN_SECONDARY = 'btn btn--secondary font-mono font-regular uppercase underline flex items-center justify-center gap-x-2 tracking-wide disable:opacity-40 disable:no-underline disable:pointer-events-none';

  function renderPagination(page, total) {
    var prevBtn = page > 0
      ? '<div class="absolute left-0 translate-x-[-125%]"><a href="#" class="' + BTN_SECONDARY + '" data-agenda-prev>' + ARROW_LEFT_SVG + ' Vorige</a></div>'
      : '<div class="absolute left-0 translate-x-[-125%]"><span class="' + BTN_SECONDARY + ' opacity-40 pointer-events-none select-none">' + ARROW_LEFT_SVG + ' Vorige</span></div>';

    var nextBtn = page < total - 1
      ? '<div class="absolute right-0 translate-x-[125%]"><a href="#" class="' + BTN_SECONDARY + '" data-agenda-next>Volgende ' + ARROW_RIGHT_SVG + '</a></div>'
      : '<div class="absolute right-0 translate-x-[125%]"><span class="' + BTN_SECONDARY + ' opacity-40 pointer-events-none select-none">Volgende ' + ARROW_RIGHT_SVG + '</span></div>';

    var pageNumbers = '';
    for (var i = 0; i < total; i++) {
      if (i === page) {
        pageNumbers += '<li><span class="agenda__pagination-number px-3 py-1 bg-foreground text-base md:text-sm text-button-text font-medium rounded-full">' + (i + 1) + '</span></li>';
      } else {
        pageNumbers += '<li><a href="#" class="agenda__pagination-number px-3 py-1 text-base md:text-sm transition-all" data-agenda-page="' + i + '">' + (i + 1) + '</a></li>';
      }
    }

    return '<nav class="agenda__pagination relative flex items-center justify-center mt-12 max-w-full w-fit mx-auto" aria-label="Pagination">'
      + prevBtn
      + '<ul class="agenda__pagination-items flex flex-row items-center justify-center gap-x-2">'
      + pageNumbers
      + '</ul>'
      + nextBtn
      + '</nav>';
  }

  // ── BIND PAGINATION EVENTS ─────────────────────────────────────────────────
  function bindPaginationEvents() {
    if (!paginationEl) return;

    var prevLink = paginationEl.querySelector('[data-agenda-prev]');
    var nextLink = paginationEl.querySelector('[data-agenda-next]');
    var pageLinks = paginationEl.querySelectorAll('[data-agenda-page]');

    if (prevLink) {
      prevLink.addEventListener('click', function (e) {
        e.preventDefault();
        if (currentPage > 0) renderPage(currentPage - 1);
      });
    }

    if (nextLink) {
      nextLink.addEventListener('click', function (e) {
        e.preventDefault();
        if (currentPage < pages.length - 1) renderPage(currentPage + 1);
      });
    }

    pageLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var p = parseInt(this.getAttribute('data-agenda-page'), 10);
        if (!isNaN(p)) renderPage(p);
      });
    });
  }

  // ── FILTER ──────────────────────────────────────────────────────────────────
  // Build chip HTML dynamically from unique sessionType values in allSessions.
  function buildFilterChips() {
    var types = [];
    allSessions.forEach(function (s) {
      if (s.product && s.product.sessionType) {
        var t = s.product.sessionType;
        if (types.indexOf(t) === -1) types.push(t);
      }
    });
    types.sort();

    // Count sessions per type
    var counts = {};
    allSessions.forEach(function (s) {
      if (s.product && s.product.sessionType) {
        var t = s.product.sessionType;
        counts[t] = (counts[t] || 0) + 1;
      }
    });

    var chipClass = 'agenda__filter-chip opacity-50 font-mono text-xs uppercase tracking-wide';

    var panelHtml = types.map(function (type) {
      var count = counts[type] || 0;
      return '<button class="' + chipClass + '" data-filter-type="' + escAttr(type) + '">'
        + escHtml(type) + ' (' + count + ')'
        + '</button>';
    }).join('');

    var panel = document.getElementById('agenda-filter-panel');
    if (panel) panel.innerHTML = panelHtml;

    document.querySelectorAll('.agenda__filter-chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var type = this.getAttribute('data-filter-type');
        var idx = activeFilters.indexOf(type);
        if (idx === -1) { activeFilters.push(type); }
        else            { activeFilters.splice(idx, 1); }
        syncChipStates();
        applyFiltersAndRender();
      });
    });
  }

  // Update underline/bold on all chips in both panels to reflect activeFilters
  function syncChipStates() {
    document.querySelectorAll('.agenda__filter-chip').forEach(function (chip) {
      var type = chip.getAttribute('data-filter-type');
      var active = activeFilters.indexOf(type) !== -1;
      chip.classList.toggle('underline',   active);
      chip.classList.toggle('font-semibold', active);
      chip.classList.toggle('opacity-50', !active);
    });
  }

  function openPanel(toggleEl) {
    var panel = document.getElementById('agenda-filter-panel');
    if (!panel) return;
    panel.classList.remove('hidden');
    panel.classList.add('flex');
    if (toggleEl) {
      toggleEl.setAttribute('aria-expanded', 'true');
      updateToggleLabel(true);
    }
  }

  function closeAllPanels() {
    var panel = document.getElementById('agenda-filter-panel');
    if (panel) { panel.classList.add('hidden'); panel.classList.remove('flex'); }
    var btn = document.getElementById('agenda-filter-toggle');
    if (btn) { btn.setAttribute('aria-expanded', 'false'); }
    updateToggleLabel(false);
  }

  // Switch toggle label between Filter≡ and Close×
  function updateToggleLabel(isOpen) {
    var label      = document.getElementById('agenda-filter-toggle-label');
    var iconFilter = document.getElementById('agenda-filter-icon-filter');
    var iconClose  = document.getElementById('agenda-filter-icon-close');
    if (label)      label.textContent = isOpen ? 'Close' : 'Filter';
    if (iconFilter) iconFilter.classList.toggle('hidden', isOpen);
    if (iconClose)  iconClose.classList.toggle('hidden', !isOpen);
  }

  function getFilteredSessions() {
    if (activeFilters.length === 0) return allSessions;
    return allSessions.filter(function (s) {
      return s.product && s.product.sessionType &&
        activeFilters.indexOf(s.product.sessionType) !== -1;
    });
  }

  function applyFiltersAndRender() {
    container.style.opacity = '0';
    setTimeout(function () {
      var filtered = getFilteredSessions();
      pages = buildPages(groupByMonth(filtered));
      if (filtered.length === 0) {
        var btnClass = BTN_SECONDARY;
        container.innerHTML =
          '<p class="agenda__empty">Geen sessies gevonden voor de geselecteerde filters.</p>'
          + '<div class="flex justify-center mt-6">'
          + '<button class="agenda__clear-btn ' + btnClass + '">Verwijder filter</button>'
          + '</div>';
        var clearBtn = container.querySelector('.agenda__clear-btn');
        if (clearBtn) {
          clearBtn.addEventListener('click', function () {
            activeFilters = [];
            syncChipStates();
            applyFiltersAndRender();
          });
        }
        if (paginationEl) paginationEl.innerHTML = '';
      } else {
        renderPage(0);
      }
      container.style.opacity = '1';
    }, 200);
  }

  function bindFilterEvents() {
    var toggle = document.getElementById('agenda-filter-toggle');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var isOpen = this.getAttribute('aria-expanded') === 'true';
        if (isOpen) { closeAllPanels(); }
        else        { openPanel(this); }
      });
    }
  }

  // ── UTILS ──────────────────────────────────────────────────────────────────
  function formatTime(isoStr) {
    if (!isoStr) return '';
    try {
      var d = new Date(isoStr);
      if (isNaN(d.getTime())) return '';
      return d.toLocaleTimeString('nl-NL', {
        timeZone: 'Europe/Amsterdam',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });
    } catch (e) {
      return '';
    }
  }

  function escHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function escAttr(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;');
  }

  document.addEventListener('DOMContentLoaded', init);
})();
